import {Injectable} from '@angular/core';
import {collection, collectionData, deleteDoc, doc, Firestore, getDoc, setDoc} from '@angular/fire/firestore';
import {IStore} from '../../shared-models/store/store';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {ISupplier} from '../../shared-models/stock/suppliers';
import {createSharedPaths} from '../database-paths.shared';

@Injectable({
  providedIn: 'root',
})
export class CollectionSharedSuppliersService {


  constructor(private firestore: Firestore) {
  }

  async setDocument<DataType>(
    path: string,
    data: DataType,
  ): Promise<void> {
    try {
      const docRef = doc(this.firestore, path);
      await setDoc(docRef, data, {merge: true});
    } catch (error) {
      console.error(error);
    }
  }

  async getDocument<DataType>(
    path: string,
  ): Promise<DataType> {
    try {
      const docRef = doc(this.firestore, path);
      const docSnapshot = await getDoc(docRef);
      if (docSnapshot.exists()) {
        return docSnapshot.data() as DataType;
      } else {
        return {} as DataType;
      }
    } catch (error) {
      console.error(error);
    }
  }

  async deleteDocument<DataType>(
    path: string,
  ): Promise<void> {
    try {
      const docRef = doc(this.firestore, path);
      await deleteDoc(docRef);
    } catch (error) {
      console.error(`Error deleting document at path: ${path}\n`, error);
    }
  }

  async updateDocumentField<DataType, NewValueType>(
    path: string,
    fieldName: string,
    newValue: NewValueType,
  ): Promise<void> {
    try {
      const updateObj: Partial<DataType> = {[fieldName]: newValue} as Partial<DataType>;
      const docRef = doc(this.firestore, path);
      await setDoc(docRef, updateObj, {merge: true});
    } catch (error) {
      console.error(`Error updating document at field: ${fieldName} with value ${String(newValue)}\n`, error);
    }
  }

  getSuppliersByStore(store: IStore): Observable<Record<string, ISupplier>> {
    const collectionRef = collection(this.firestore, createSharedPaths().setStoreId(store.storeId).suppliers());
    return collectionData(collectionRef, {idField: 'id'})
      .pipe(
        map((docs: ISupplier[]) => {
          const suppliers: Record<string, ISupplier> = {};
          docs.forEach((supplierData: ISupplier): void => {
            const suppId = supplierData.account;
            suppliers[suppId] = supplierData;
            suppliers[suppId].supplierId = supplierData.account;
            suppliers[suppId].isSupplierSelected = false;
          });
          return suppliers;
        }),
      );
  }


}
